// Apple Button Style Overrides
// ─────────────────────────────────────────────────────────────────────────────

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          textTransform: 'none',
          letterSpacing: 0,
          transition: 'all 0.15s ease',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        sizeLarge: {
          height: 44,
        },
        sizeMedium: {
          height: 36,
        },
        sizeSmall: {
          height: 28,
          borderRadius: 14,
        },
        containedPrimary: {
          backgroundColor: '#007AFF',
          borderRadius: 20,
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#0066CC',
            boxShadow: 'none',
          },
        },
        containedSecondary: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        containedInherit: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        outlinedPrimary: {
          borderRadius: 20,
        },
        outlinedSecondary: {
          borderRadius: 20,
        },
      },
    },
  };
}
